import React from 'react'
import ReactDOM from 'react-dom/client'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { StoreProvider } from 'easy-peasy'
import { HelmetProvider } from 'react-helmet-async'

import {
	Home,
	Directory,
	DirectoryDetailPage,
	Event,
	EventDetailPage,
	PromotionPage,
	PromotionDetailPage,
	ArticlePage,
	PrivacyPolicy
} from '@pages'

import stores from '@stores'

import reportWebVitals from './reportWebVitals'
import './index.css'

const router = createBrowserRouter([
	{
		path: '/',
		element: <Home />
	},
	{
		path: '/directory',
		element: <Directory />
	},
	{
		path: '/directory/:slug',
		element: <DirectoryDetailPage />
	},
	{
		path: '/event',
		element: <Event />
	},
	{
		path: '/event/:slug',
		element: <EventDetailPage />
	},
	{
		path: '/promotion',
		element: <PromotionPage />
	},
	{
		path: '/promotion/:slug',
		element: <PromotionDetailPage />
	},
	{
		path: '/article',
		element: <ArticlePage />
	},
	{
		path: '/privacy-policy',
		element: <PrivacyPolicy />
	},
	{
		path: '*',
		element: (
			<div className="flex justify-center items-center h-dvh text-5xl text-primary">
				404
			</div>
		)
	}
])

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
	<React.StrictMode>
		<HelmetProvider>
			<StoreProvider store={stores}>
				<RouterProvider router={router} />
			</StoreProvider>
		</HelmetProvider>
	</React.StrictMode>
)

reportWebVitals()
